import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface Category {
  id: string;
  name: string;
  description: string;
  status: string;
  created_at: string | Date;
}

export interface Tag {
  id: string;
  name: string;
  created_at: string | Date;
  category_id: string;
}
@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private categoryUpdate: BehaviorSubject<boolean> = new BehaviorSubject(false);
  categoryUpdate$: Observable<boolean> = this.categoryUpdate.asObservable();
  private categories: Category[] = [];
  private tags: Tag[] = [];

  constructor() { }

  private selectedCategory: string = sessionStorage.getItem('selectedCategory') || "";

  setCategoryData(data: any[]): void {
    const that = this;
    data.forEach(function (category: any) {
      category.tags.forEach(function (tag: any) {
        that.tags.push({ 
          id: tag.id, 
          name: tag.name, 
          created_at: tag.created_at, 
          category_id: tag.category_id 
        });
      });

      that.categories.push({
        id: category.id,
        name: category.name,
        status: category.status,
        created_at: category.created_at,
        description: category.description
      });
    });

    this.categoryUpdate.next(true);
  }

  getCategoryData(): Category[] {
    return this.categories;
  }

  getTagsData(): Tag[] {
    return this.tags;
  }

  /**
   * Set selected category
   * @param id 
   */
  setSelectedCategory(id: string): void {
    this.selectedCategory = id;
    if (id) {
      sessionStorage.setItem('selectedCategory', id);
    } else {
      sessionStorage.removeItem('selectedCategory');
    }
  }

  /**
   * Get selected category
   * @returns 
   */
  getSelectedCategory(): string {
    return this.selectedCategory;
  }

}